import { graphql } from "src/graphql/generated";

export const approveReviewMutation = graphql(/* GraphQL */ `
    mutation ApproveReview($clientId: String!, $reviewId: String!) {
        approveReview(clientId: $clientId, reviewId: $reviewId) {
            id
            state
        }
    }
`);

export const sendReviewCommentMutation = graphql(/* GraphQL */ `
    mutation SendReviewComment($clientId: String!, $reviewId: String!, $content: String!) {
        sendReviewComment(clientId: $clientId, reviewId: $reviewId, content: $content) {
            id
        }
    }
`);
